export function EmailIcon({ className }: { className?: string }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M1.66667 5.83398L8.47077 10.5969C9.02175 10.9825 9.29724 11.1754 9.59689 11.2501C9.86158 11.3161 10.1384 11.3161 10.4031 11.2501C10.7028 11.1754 10.9783 10.9825 11.5292 10.5969L18.3333 5.83398M5.66667 16.6673H14.3333C15.7335 16.6673 16.4335 16.6673 16.9683 16.3948C17.4387 16.1552 17.8212 15.7727 18.0609 15.3023C18.3333 14.7675 18.3333 14.0674 18.3333 12.6673V7.33398C18.3333 5.93385 18.3333 5.23379 18.0609 4.69901C17.8212 4.2286 17.4387 3.84615 16.9683 3.60647C16.4335 3.33398 15.7335 3.33398 14.3333 3.33398H5.66667C4.26654 3.33398 3.56647 3.33398 3.0317 3.60647C2.56129 3.84615 2.17884 4.2286 1.93916 4.69901C1.66667 5.23379 1.66667 5.93385 1.66667 7.33398V12.6673C1.66667 14.0674 1.66667 14.7675 1.93916 15.3023C2.17884 15.7727 2.56129 16.1552 3.0317 16.3948C3.56647 16.6673 4.26654 16.6673 5.66667 16.6673Z"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
